import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { CardBatch } from '../../../../models/loyalty-card-batch.model';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { LoyaltyCardBatchService } from '../../../../services/loyalty/loyalty-card-batch.service';
import { LoyaltyChannelService } from '../../../../services/loyalty/loyalty-channel.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { CustomerCluster } from './../../../../models/loyalty-cluster.model';
import { CalendarTranslateService } from './../../../../modules/UIKit/services/calendarTranslate.service';
import { CustomerClusterService } from './../../../../services/customer/customer-cluster.service';
import { LoyaltyCardDefinitionService } from './../../../../services/loyalty/loyalty-card-definition.service';
import { LoyaltyClusterService } from './../../../../services/loyalty/loyalty-cluster.service';
import { LoyaltyParamsService } from './../../../../services/loyalty/params.service';


@Component({
  selector: 'app-form-card-definition-batch',
  templateUrl: './form-card-batch.component.html',
  styleUrls: ['./form-card-batch.component.css']
})
export class FormCardBatchComponent implements OnInit {

  @ViewChild('clusterHead') elemClusterHead: any;

  fields: any;
  public validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative,
    notNull: Validators.nullValidator
  };

  // title: string;

  render = {
    form: false,
    channel: false,
    store: false,
    clusterHead: false,
    cardDefinitions: false,
    messageConflict: false
  };

  form: FormGroup;
  @Input() cardbatchId: string;
  @Input() editMode: boolean;
  clustersHead: Array<CustomerCluster>;
  channels: { value: string, label: string }[];
  clusters: { value: string, label: string }[];
  cardTypes: { value: string, label: string }[];
  listDeploy: { value: string, label: string }[];
  stores: { value: number, label: string }[];
  cardDefinitions: { value: string, label: string }[];

  messageConflict = '';
  readonly = false;

  selected = {
    clusterHead: null,
    checkClusterHead: false
  }

  public invalidSubmit: boolean;

  public stringCards = '';

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private cardBatchService: LoyaltyCardBatchService,
    private channelService: LoyaltyChannelService,
    private storeService: StoreCommonService,
    private paramService: LoyaltyParamsService,
    private customerClusterService: CustomerClusterService,
    private cardDefinitionService: LoyaltyCardDefinitionService,
    private calendarTranslate: CalendarTranslateService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {

    this.channels = [{value: null, label: ''}];
    this.clusters = sessionStorage.getItem('cardBatchClusters') ? JSON.parse(sessionStorage.getItem('cardBatchClusters')) : [{value: null, label: ''}];
    this.cardTypes  = sessionStorage.getItem('cardBatchListTypeCard') ? JSON.parse(sessionStorage.getItem('cardBatchListTypeCard')) : [{value: null, label: ''}];
    this.listDeploy = sessionStorage.getItem('cardBatchListDeploy') ? JSON.parse(sessionStorage.getItem('cardBatchListDeploy')) : [{value: null, label: ''}];

    this.stores = [{value: null, label: ''}];
    this.cardDefinitions = [{value: null, label: ''}];

    this.cardBatchService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.channelService.list().subscribe(
      res => {
        for ( const channel of res.data) {
          this.channels.push(
            {
              label: channel.channelDescription,
              value: channel.id
            }
          );
        }
        this.render.channel = true;
      }
    );

    const paramCardType = [
      {key: 'param_group', value: 'CardType'}
    ];

    let CardTypeList: Observable<any>;
    if (!sessionStorage.getItem('cardBatchListTypeCard')) {
      CardTypeList =  this.paramService.list(null, null, paramCardType);
    }

    if (CardTypeList) {
      Observable.zip(
        CardTypeList
        ).subscribe(([
          resCardTypeList
        ]) => {
          if (!sessionStorage.getItem('cardBatchListTypeCard')) {
            for (const singleCardType of resCardTypeList.data) {
              this.cardTypes.push({
                label: singleCardType.description,
                value: singleCardType.id
              });
            }
            sessionStorage.setItem('cardBatchListTypeCard', JSON.stringify(this.cardTypes));
          }
      });
    }

    this.cardbatchId = this.activatedRoute.snapshot.params['cardbatchId'];
    this.editMode = (typeof this.cardbatchId !== 'undefined');
    let cardBatch: Observable<any>;

    if (!this.editMode) {
      cardBatch = Observable.of(new CardBatch());
    } else {
      cardBatch = this.cardBatchService.get(this.cardbatchId);
    }

    cardBatch.subscribe((res) => {
      if (res.channel_id) {
        this.customerClusterService.getClusterHeadListSoloSchedaCliente('', '').subscribe(clusterHeads => {
          this.selected.clusterHead = clusterHeads.data.filter(ch => ch.clusterHeadId === res.cluster_head_id)[0];
        });
        this.storeService.getListFilteredByChannel(res.channel_id).subscribe(
          (stores) => {
            for ( const store of stores) {
              this.stores.push(
                {
                  value: store.id,
                  label: store.code + (store.name ? ' - ' + store.name : '')
                }
              );
            }
          },
          error => console.error(error),
          () => {
            this.cardDefinitionService.list(null, null, [{key: 'channelId', value: res.channel_id.toString()}]).subscribe(
              (cardDefs) => {
                for ( const cardDefinition of cardDefs.data) {
                  let cardSuffix = cardDefinition['cardSuffix'] ? cardDefinition['cardSuffix'] : '';
                  this.cardDefinitions.push(
                    {
                      label: cardDefinition['cardPrefix'] + cardSuffix + ' - ' + cardDefinition.description,
                      value: cardDefinition.id
                    }
                  );
                }
                this.form = this.fb.group({
                  channel_id: [res.channel_id || null],
                  store_id: [res.store_id || null],
                  num_min: [res.num_min || null],
                  num_max: [res.num_max || null],
                  card_type_pid: [res.card_type_pid || null],
                  card_def_id: [res.card_def_id || null],
                  cluster_head_id: [res.cluster_head_id || null, Validators.compose([Validators.required, Validators.nullValidator])],
                  flg_initial_state: [res.flg_initial_state || '0', Validators.compose([Validators.required, KoncentroValidators.integerNotNegative])],
                });
                this.render.store = true;
                this.render.cardDefinitions = true;
                this.render.form = true;
              }
            );
          });
      } else {
        this.form = this.fb.group({
          channel_id: [res.channel_id || null],
          store_id: [res.store_id || null],
          num_min: [res.num_min || null],
          num_max: [res.num_max || null],
          card_type_pid: [res.card_type_pid || null],
          card_def_id: [res.card_def_id || null],
          cluster_head_id: [res.cluster_head_id || null,Validators.required],
          flg_initial_state: [res.flg_initial_state || '0', Validators.compose([Validators.required, KoncentroValidators.integerNotNegative])],
        });
        this.render.form = true;
      }
    });

  }

  filterClusterHeadSingle(event) {
    const self = this;
    this.customerClusterService.getClusterHeadListSoloSchedaCliente(event.query, '')
      .subscribe(filtered => {
        if (filtered && filtered.data) {
          // self.clustersHead = filtered.data;
          self.clustersHead = new Array<CustomerCluster>();
          for (let ce of filtered.data) {
            let dateEnd = new Date(ce.date_end);
            let dateStart = new Date(ce.date_start);
            let now = new Date();
            if (dateEnd > now) {
              ce.headDescription = this.getTransformClusterHeadDescriptionNew(dateStart, dateEnd, ce.headDescription, ce.code);
              self.clustersHead.push(ce);
            }
          }
        }
    });
  }

  getTransformClusterHeadDescription(dateEnd: Date, description: string) {
    let res = '';
    if (dateEnd) {
      res = this.datePipe.transform(dateEnd, this.calendarTranslate.pcalendarTranslate.dateFormatFilter) + ' - ' + description;
    }
    return res;
  }

  getTransformClusterHeadDescriptionNew(dateStart: Date, dateEnd: Date, description: string, code: string) {
    let codeStr = code ? " (CODE: "+code+ ")":"";
    let res = description + ' - ' + this.datePipe.transform(dateStart, this.calendarTranslate.pcalendarTranslate.dateFormatFilter) + ' / '
        + this.datePipe.transform(dateEnd, this.calendarTranslate.pcalendarTranslate.dateFormatFilter) + codeStr ;

    return res;
  }

  clusterHeadIdSelect(event) {
  }
  checkClusterSelected(event){
    if(!this.selected.clusterHead || !this.selected.clusterHead.clusterHeadId){
      this.form.get('cluster_head_id').setValue(null);
      this.invalidSubmit = true;
      this.selected.checkClusterHead = true;
      return;
    }
    this.selected.checkClusterHead = false;
  }
  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    this.invalidSubmit = false;
    this.render.messageConflict = false;
    this.messageConflict = '';
    const cardBatch = new CardBatch();
    cardBatch.channel_id = this.form.get('channel_id').value;
    cardBatch.store_id = this.form.get('store_id').value;
    cardBatch.num_min = this.form.get('num_min').value;
    cardBatch.num_max = this.form.get('num_max').value;
    cardBatch.card_type_pid = this.form.get('card_type_pid').value;
    cardBatch.card_def_id = this.form.get('card_def_id').value;
    cardBatch.flg_initial_state = this.form.get('flg_initial_state').value;
    cardBatch.cluster_head_id = (this.selected.clusterHead && this.selected.clusterHead.clusterHeadId) ? this.selected.clusterHead.clusterHeadId : null;

    /*** decommentare se si vuole abilitare il dropdown dello stato del deploy ***/
    // cardBatch.flg_dpl = this.form.get('deploy').value;

    this.verifyExistingCardBatch(cardBatch);

    /*
      if (!this.editMode) {
        this.cardBatchService.create(cardBatch).subscribe(() => {
          this.router.navigate(['/loyalty/card_batch']);
        });
      }else {
        cardBatch.id = this.cardbatchId;
        this.cardBatchService.update(cardBatch).subscribe(() => {
          this.router.navigate(['/loyalty/card_batch']);
        });
      }
    */
  }

  changeMin(event, max) {
    if (max && (event.target.value > max)) {
      event.target.value = max;
    }
  }

  changeMax(event, min) {
    if (min && (event.target.value < min)) {
      event.target.value = min;
    }
  }

  onChannelChange(init = false) {
    const cardDefFilters = [];
    const storeFilters = [];

    this.stores = [{value: null, label: ''}];
    this.cardDefinitions = [{value: null, label: ''}];

    /*** annullo la selezione del dropdown di cardDef  ***
     *   OSS: questo metodo viene richiamato anche nell'init, quindi se siamo in fase di init (passaggio parametro booleano true)
     *        non annulliamo niente, altrimenti in fase di edit verrebbe annullato in valore di card_def
     * ***/

    if (init === false) {
      this.form.get('card_def_id').setValue(null);
      this.form.get('store_id').setValue(null);
    }

    let channelValue = +this.form.get('channel_id').value;

    /***
     * il canale canale deve essere scelto per abilitare la combo cardDef e la combo negozi
     * ***/

    if (+channelValue > 0) {
      cardDefFilters.push(
        { key: 'channelId', value: channelValue.toString() }
      );

      storeFilters.push(
        { key: 'channel_loyalty_id', value: channelValue.toString() }
      );

      this.storeService.getListFilteredByChannel(channelValue).subscribe(
        (res) => {
          for ( const store of res) {
            this.stores.push(
              {
                value: store.id,
                label: store.code + (store.name ? ' - ' + store.name : '')
              }
            );
          }
          this.render.store = true;
        }
      );

      this.cardDefinitionService.list(null, null, [{key: 'channelId', value: channelValue.toString()}]).subscribe(
        (res) => {
          for ( const cardDefinition of res.data) {
            let cardSuffix = cardDefinition['cardSuffix'] ? cardDefinition['cardSuffix'] : '';
            this.cardDefinitions.push(
              {
                label: cardDefinition['cardPrefix'] + cardSuffix + ' - ' + cardDefinition.description,
                value: cardDefinition.id
              }
            );
          }
          this.render.cardDefinitions = true;
        }
      );
    } else {
      this.form.get('store_id').setValue(null);
      this.render.store = false;
      this.form.get('card_def_id').setValue(null);
      this.render.cardDefinitions = false;
    }
  }

  /*
  NOTA (federico): il metodo onChannelOrClusterChange non viene più usato, ma lo tengo perchè era prima richiesto e poi non richiesto più e può sempre tornare utile in caso di ulteriore ripensamento
  */

  onChannelOrClusterChange(init = false) {

    const cardDefFilters = [];
    const storeFilters = [];

    this.stores = [{value: null, label: ''}];
    this.cardDefinitions = [{value: null, label: ''}];

    /*** annullo la selezione del dropdown di cardDef  ***
     *   OSS: questo metodo viene richiamato anche nell'init, quindi se siamo in fase di init (passaggio parametro booleano true)
     *        non annulliamo niente, altrimenti in fase di edit verrebbe annullato in valore di card_def
     * ***/
    if (init === false) {
      this.form.get('card_def_id').setValue(null);
      this.form.get('store_id').setValue(null);
    }

    let channelValue = +this.form.get('channel_id').value;
    let clusterValue = +this.form.get('cluster_head_id').value;

    /***
     * almeno uno tra canale o cluster deve essere scelto per abilitare la combo cardDef
     * NOTA: "almeno uno" perchè il cluster non è un dato obbligatorio, perciò non possiamo forzare l'utente a scegliere un cluster
     * ***/
    if (+channelValue > 0 || +clusterValue > 0) {
      if (+channelValue > 0) {

        cardDefFilters.push(
          { key: 'channelId', value: channelValue.toString() }
        );

        storeFilters.push(
          { key: 'channel_loyalty_id', value: channelValue.toString() }
        );

        this.storeService.getListFilteredByChannel(channelValue).subscribe(
          (res) => {
            for ( const store of res) {
              this.stores.push(
                {
                  value: store.id,
                  label: store.code + (store.description ? ' - ' + store.description : '')
                }
              );
            }
            this.render.store = true;
          }
        );

      } else {
        this.form.get('store_id').setValue(null);
        this.render.store = false;
      }

      if (+clusterValue > 0) {
        cardDefFilters.push(
          {
            key: 'clusterId',
            value: clusterValue.toString()
          }
        );
      }

      this.cardDefinitionService.list(channelValue).subscribe(
        (res) => {
          for ( const cardDefinition of res.data) {
            let cardSuffix = cardDefinition['cardSuffix'] ? cardDefinition['cardSuffix'] : '';
            this.cardDefinitions.push(
              {
                label: cardDefinition['cardPrefix'] + cardSuffix + ' - ' + cardDefinition.description,
                value: cardDefinition.id
              }
            );
          }
          this.render.cardDefinitions = true;
        }
      );

    } else {
      this.form.get('store_id').setValue(null);
      this.render.store = false;
      this.form.get('card_def_id').setValue(null);
      this.render.cardDefinitions = false;
    }
  }

  verifyExistingCardBatch(cardBatch: CardBatch) {

    this.cardBatchService.verifyExistingCardBatch(cardBatch).subscribe(res => {
      if (res && res.length > 0) {

        for (const card of res) {
          this.stringCards += ' ' + card + ';';
        }

        // this.srvNotify.add({severity: 'error', summary: this.fields.warning, detail: this.fields.warningCardConflict + ":" + stringCards});
        this.translate.get(['card_batch.verify_card_failed']).subscribe(
          translations => this.messageConflict = translations['card_batch.verify_card_failed'],
          error => console.log(error),
          () => this.render.messageConflict = true
        )
      } else {
        if (!this.editMode) {
          this.cardBatchService.create(cardBatch).subscribe(() => {
            this.router.navigate(['/loyalty/card_batch']);
          });
        } else {
          cardBatch.id = this.cardbatchId;
          this.cardBatchService.update(cardBatch).subscribe(() => {
            this.router.navigate(['/loyalty/card_batch']);
          });
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-batch/form-card-batch/form-card-batch.component.ts